import {reportQuotaUsage} from '@wix/ambassador-premium-features-manager-v1-feature/http';
import {AppReflowPremiumFeatureName} from '../constants';
import {IHttpClient} from '@wix/http-client';

export const reportPremiumQuotaUsage = (
  featureId: AppReflowPremiumFeatureName,
  httpClient: IHttpClient,
  msid: string,
  quotaChange: string
) => {
  return httpClient.request(
    reportQuotaUsage({
      msid,
      uniqueName: featureId,
      incrementBy: quotaChange,
    })
  );
};
